import { color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-link";
const linkBase = {
  position: "relative",
  backgroundPosition: "left calc(100% - 1px)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 1px",
  transition: "color 0.5s, background-size 0.5s, background-image 0.5s, background-position 0.5s"
};
const focusBase = {
  backgroundPosition: "left calc(100%)",
  textDecoration: "none !important",
  backgroundSize: "100% 1px"
};
function composeLink(options) {
  const { color: linkColor = "red" } = options || {};
  let composed = {
    ...linkBase
  };
  if (linkColor === "red") {
    composed = {
      ...composed,
      color: color.black,
      backgroundImage: "linear-gradient(#000000, #000000)",
      "&:hover, &:focus": {
        ...focusBase,
        backgroundImage: `linear-gradient(${color.red}, ${color.red})`,
        color: `${color.black} !important`
      }
    };
  } else if (linkColor === "white") {
    composed = {
      ...composed,
      color: color.white,
      backgroundImage: "linear-gradient(#ffffff, #ffffff)",
      "&:hover, &:focus": {
        ...focusBase,
        backgroundImage: `linear-gradient(${color.gold}, ${color.gold})`,
        color: `${color.white} !important`
      }
    };
  }
  const className = `${classNamePrefix}-${linkColor}`;
  return objectWithClassName({
    ...composed,
    className
  });
}
const red = composeLink({ color: "red" });
const white = composeLink({ color: "white" });
export {
  composeLink,
  red,
  white
};
//# sourceMappingURL=link.js.map
